import { jsx as _jsx } from "react/jsx-runtime";
export const MagnifyingGlassS = ({ color, ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.5 3.25C14.5041 3.25 17.75 6.49594 17.75 10.5C17.75 12.2318 17.1411 13.8205 16.1279 15.0674L20.082 19.0264C20.3223 19.3209 20.3049 19.7557 20.0303 20.0303C19.7557 20.3049 19.3209 20.3223 19.0264 20.082L15.0674 16.1279C13.8205 17.1411 12.2318 17.75 10.5 17.75C6.49594 17.75 3.25 14.5041 3.25 10.5C3.25 6.49594 6.49594 3.25 10.5 3.25ZM10.5 4.75C7.32436 4.75 4.75 7.32436 4.75 10.5C4.75 13.6756 7.32436 16.25 10.5 16.25C13.6756 16.25 16.25 13.6756 16.25 10.5C16.25 7.32436 13.6756 4.75 10.5 4.75Z",
            fill: color ?? 'currentColor'
        })
    });

//# sourceMappingURL=magnifying-glass-s.js.map